global.conmed = global.conmed || {};

conmed.banners = function ($) {

    'use strict';
    var that = {
        selectors: {

        }
    };

    // Create and show loading spinner overlay
    function showLoadingSpinner() {
        // Remove existing spinner if any
        $('#country-loading-overlay').remove();

        var spinnerHtml = '<div id="country-loading-overlay" style="' +
            'position: fixed; top: 0; left: 0; width: 100%; height: 100%; ' +
            'background: rgba(255, 255, 255, 0.8); z-index: 99999; ' +
            'display: flex; justify-content: center; align-items: center;">' +
            '<div style="text-align: center;">' +
            '<div class="spinner-border" role="status" style="width: 3rem; height: 3rem; color: #0066b3;">' +
            '<span class="visually-hidden">Loading...</span>' +
            '</div>' +
            '<div style="margin-top: 15px; font-size: 16px; color: #333;">Loading...</div>' +
            '</div></div>';

        $('body').append(spinnerHtml);
    }

    that.init = function () {
        const Cookies = require('js-cookie')

        var currentCountry = $('input[name="currentCountry"]').val();
        var excludedCountries = $('input[name="excludedCountries"]').val();

        // Check if we should show the DNE banner
        var showDneBanner = false;

        // Show if current country is in excluded list
        if (excludedCountries.indexOf(currentCountry) > -1) {
            showDneBanner = true;
        }

        // Also show if we're on the page-not-available page (redirected due to missing language version)
        var urlParams = new URLSearchParams(window.location.search);
        if (window.location.pathname.indexOf('page-not-available') > -1 || urlParams.has('dne')) {
            showDneBanner = true;
        }

        if (showDneBanner) {
            //find and show the does not exist banner
            var doesNotExistBanner = $('.language-banner[data-bannertype=\'dne\']');

            if (doesNotExistBanner != 'undefined' && doesNotExistBanner.length > 0) {
                $(doesNotExistBanner).addClass('active');
            }
        }

        $('a.language-item').on('click', function (e) { 
            e.preventDefault();
            var languageBanner = $('.language-banner[data-bannertype=\'language\']');

            if (languageBanner != 'undefined' && languageBanner.length > 0) {
                var agreeButton = $(languageBanner).find('.agree-button');
                $(agreeButton).attr('data-redirect', $(e.currentTarget).attr('href'));
                $(languageBanner).addClass('active');
                return;
            }
            else {
                var redirect = $(e.currentTarget).attr('href');
                window.location.replace(redirect);
            }
        })

        $('a.country-item').on('click', function (e) {
            e.preventDefault();

            var countryBanner = $('.language-banner[data-bannertype=\'country\']');
            var countryId = $(this).data('country');        

            if (countryBanner != 'undefined' && countryBanner.length > 0) {
                var agreeButton = $(countryBanner).find('.agree-button');
                $(agreeButton).attr('data-redirect', $(e.currentTarget).attr('href'));
                $(agreeButton).attr('data-country', countryId);
                $(countryBanner).addClass('active');
            }
            else {
                // Show loading spinner while changing country
                showLoadingSpinner();

                $.ajax({
                    type: 'POST',
                    url: '/webapi/setcurrentcountry?requestedCountry=' + countryId,
                    success: function (data) {
                        // Force fresh page load to bypass CDN cache
                        var url = window.location.pathname + '?_c=' + Date.now();
                        window.location.href = url;
                    },
                    error: function (XMLHttpRequest, textStatus, errorThrown) {
                        // Hide spinner on error
                        $('#country-loading-overlay').remove();
                        //console.log("error: " + textStatus + " " + errorThrown);
                    }
                });
            }


        })

        $('.language-banner .agree-button').on('click', function (e) {

            e.preventDefault;
            var languageBanner = $(this).closest('.language-banner');

            const redirect = $(e.currentTarget).attr('data-redirect');

            

            if (languageBanner != 'undefined') {

                $(languageBanner).removeClass('active');

                var bannerType = $(languageBanner).attr('data-bannertype');

                //set this here if its medical incase we redirect before we get a chance to set it
                if (bannerType == "medical")
                    sessionStorage.setItem('medicalBanner', 'true');                
                
                if (bannerType == "dne") {

                    var agreeButton = $(languageBanner).find('.agree-button');
                    var agreeRedirect = $(agreeButton).attr('data-redirect');                    

                    var lang = window.location.href.split('/')[3];

                    if (agreeRedirect == "") {

                        if (document.referrer == "") {
                            window.location.replace('/' + lang);
                            return;
                        }
                        if (document.referrer != "" && document.referrer.includes("conmed.com")) {
                            window.location.replace(document.referrer);
                            return;
                        }
                        else {
                            window.location.replace('/' + lang);
                            return;
                        }
                    }

                    else {
                        window.location = agreeRedirect;
                    }
                }

                if (bannerType == "country" || bannerType == "language") {

                    var countryId = $(this).data('country');

                    if (redirect && redirect.length)
                    {
                        if (redirect.indexOf("ja") >= 0) {
                            Cookies.set("CurrentCountry", "japan");
                            countryId = "japan"
                        }
                    }

                    // Show loading spinner while changing country
                    showLoadingSpinner();

                    $.ajax({
                        type: 'POST',
                        url: '/webapi/setcurrentcountry?requestedCountry=' + countryId,
                        success: function (data) {
                            // Add cache-busting param to bypass CDN cache
                            var cacheBust = (redirect.indexOf('?') > -1 ? '&' : '?') + '_c=' + Date.now();
                            window.location.replace(redirect + cacheBust);
                        },
                        error: function (XMLHttpRequest, textStatus, errorThrown) {
                            // Hide spinner on error
                            $('#country-loading-overlay').remove();
                            //console.log("error: " + textStatus + " " + errorThrown);
                        }
                    });
                }


            }

        })

        $('.language-banner .cancel-button').on('click', function (e) {

            e.preventDefault;
            var languageBanner = $(this).closest('.language-banner');
            if (languageBanner != 'undefined') {

                $(languageBanner).removeClass('active');                              

                const redirect = $(e.currentTarget).attr('data-redirect');
                var setCountry = $(e.currentTarget).attr('data-country');

                var countryId = $('input[name="currentCountry"]').val();

                if (redirect && redirect.length) {

                    if (setCountry && setCountry.length) {
                        Cookies.set("CurrentCountry", setCountry);
                        countryId = setCountry;
                    }

                    $.ajax({
                        type: 'POST',
                        url: '/webapi/setcurrentcountry?requestedCountry=' + countryId,
                        success: function (data) {
                            // Add cache-busting param to bypass CDN cache
                            var cacheBust = (redirect.indexOf('?') > -1 ? '&' : '?') + '_c=' + Date.now();
                            window.location.replace(redirect + cacheBust);
                        },
                        error: function (XMLHttpRequest, textStatus, errorThrown) {
                            //console.log("error: " + textStatus + " " + errorThrown);
                        }
                    });
                }

                var bannerType = $(languageBanner).attr('data-bannertype');
                if (bannerType == "dne") {

                    var cancelButton = $(languageBanner).find('.cancel-button');
                    var cancelRedirect = $(cancelButton).attr('data-redirect');
                    var lang = window.location.href.split('/')[3];

                    if (cancelRedirect == "") {

                        if (document.referrer == "") {
                            window.location.replace('/' + lang);
                            return;
                        }
                        if (document.referrer != "" && document.referrer.includes("conmed.com")) {
                            window.location.replace(document.referrer);
                            return;
                        }
                        else {
                            window.location.replace('/' + lang);
                            return;
                        }
                    }
                    else {
                        window.location = cancelRedirect;
                    }
                }
            }

        })

        var medicalBanner = $('.language-banner[data-bannertype=\'medical\']');

        if (sessionStorage.getItem('medicalBanner') != 'true') {
            $(medicalBanner).addClass('active');
        }
    };

    return that;
}(jQuery);